import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('PlatformListItem').create(({ theme }) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start',
    gap: '16px',
    color: theme.colors.text.primary,
    borderRadius: '12px',
    backgroundColor: theme.colors.button.secondary.background,

    padding: '12px',
    paddingRight: '0px',
    width: '100%',
    maxWidth: '300px',
    maxHeight: '300px',
    boxShadow: 'none !important',
    height: '120px',

    '&[disabled]': {
      opacity: '0.5',
    },

    '&[data-status="Not Connected"]': {
      animation: 'jamp 1s infinite ease alternate',
    },

    '@keyframes jamp': {
      '0%': {
        transform: 'scale(0.97)',
        boxShadow: '0 0px 0px rgba(0,0,0,0)',
        background: '#252528',
      },

      '20%': {
        transform: 'scale(0.98)',
        boxShadow: '0 0px 0px rgba(0,0,0,0)',
        background: '#252528',
      },

      '100%': {
        transform: 'scale(1)',
        boxShadow: '0 4px 20px rgba(74,107,252,.05)',
        background: '#24252B',
      },
    },
  },

  dragHelper: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    zIndex: 20,
    borderRadius: '12px',

    '&[data-disabled="false"]': {
      cursor: 'pointer',
    },

    '&[data-disabled="true"]': {
      display: 'none',
    },
  },

  statusWrapper: {
    display: 'flex',
    gap: '6px',

    '&[data-status="Connected"]': {
      '& > div': {
        backgroundColor: 'rgba(30, 255, 0, 1)',
      },
      '& > p': {
        color: 'rgba(30, 255, 0, 1)',
      },
    },

    '&[data-status="Available"]': {
      '& > div': {
        backgroundColor: 'white',
      },
      '& > p': {
        color: 'white',
      },
    },
    '&[data-status="Legacy"]': {
      '& > div': {
        backgroundColor: 'white',
      },
      '& > p': {
        color: 'white',
      },
    },

    '&[data-status="Soon"]': {
      '& > div': {
        backgroundColor: 'rgba(117, 119, 120, 1)',
      },
      '& > p': {
        color: 'rgba(117, 119, 120, 1)',
      },
    },
  },

  dot: {
    width: '6px',
    aspectRatio: '1/1',
    alignSelf: 'center',
    borderRadius: '100%',
  },

  imageWrapper: {
    display: 'flex',
    width: '100%',
    paddingRight: '12px',
    justifyContent: 'space-between',
  },

  img: {
    width: '36px',
    height: '36px',
    borderRadius: '8px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  infoWraper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start',
    justifyContent: 'center',
    textTransform: 'none',
    fontSize: theme.sizes.texts.fontSize.m,
    lineHeight: theme.sizes.texts.lineHeight.xl,

    color: theme.colors.text.primary,
    p: {
      margin: 0,
      padding: 0,
    },
  },


  nameWrapper: { display: 'flex', width: '100%', gap: '4px', alignItems: 'center', justifyContent: 'space-between' },

  name: {
    display: 'flex',
    fontWeight: '450',
    fontSize: '16px',
    lineHeight: theme.sizes.texts.lineHeight.xl,

    textWrap: 'wrap',
    textAlign: 'left',
  },

  status: {
    fontWeight: '450',
    fontSize: theme.sizes.texts.fontSize.s,
    lineHeight: theme.sizes.texts.lineHeight.m,

    color: theme.colors.text.secondary,

    '&[data-status="Connected"]': {
      color: theme.colors.text.success,
    },

    '&[data-status="Not Connected"]': {
      span: {
        color: '#E83550',
      },
    },
  },
}))
